import React from 'react'
import { Spinner } from 'react-bootstrap'

/**
 * Full-page centered loader
 * Used when loading entire page content
 * Displays a large spinner centered in the viewport
 */
const PageLoader: React.FC = () => {
  return (
    <div className="d-flex justify-content-center align-items-start align-items-md-center min-vh-100 pt-5 pt-md-0">
      <div className="text-center">
        <Spinner
          animation="border"
          variant="dark"
          style={{ width: '3rem', height: '3rem' }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </div>
  )
}

export default PageLoader